import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import * as io from 'socket.io-client'
import { environment } from 'src/environments/environment'
import { HelperService } from './helper.service'
import { HttpClient } from '@angular/common/http'
import { getLoggedUser } from '../_helpers/LocalStorage'

@Injectable()
export class WebsocketService {
	constructor(private router: Router, private helper: HelperService, private http: HttpClient) {}

	private readonly SOCKET_URL = environment.PATH.replace('/api', '')
	public static socket: any

	public accessWebSocket(): Promise<boolean> {
		return new Promise<boolean>(async (resolve, reject) => {

			if (this.helper.getUserIp() == null) {
				const ipAddress = await this.helper.getIpAddress()
				this.helper.setIpAddress(ipAddress)
			}

			const ipAddress = this.helper.getUserIp()
			const currentUser = getLoggedUser()
			const accessToken = JSON.parse(localStorage.getItem('access_token'))
			
			const socket = io(this.SOCKET_URL, 
			{ 
				transportOptions: {
						polling: {
								extraHeaders: {
										'Authorization': accessToken,
								}
						}
				},
				query: { 
					email: currentUser.email, 
					ip: ipAddress, 
					source: 'PAINEL' 
				} 
			})

			socket.on('connect', () => {
				console.log('Socket ID: ' + socket.id)
				this.helper.setWebsocket(socket)
				resolve(true)
			})

			const errorHandler = (eventData: string) => {
				socket.disconnect()
				localStorage.setItem(eventData, 'true')

				// Conexões máximas só remove o navegador logado no momento do limite
				if(eventData !== 'limitConnectionReached') {
					this.helper.setAlreadyConnectedInWebsocket(false)
					this.helper.clearLocalStorage()
				}

				this.router.navigate(['/login'])
				resolve(true)
			}

			socket.on('logout', () => errorHandler('isForcedLogout'))
			socket.on('blocked', () => errorHandler('userIsBlocked'))
			socket.on('inactive', () => errorHandler('userIsInactive'))
			socket.on('limitConnectionReached', () => errorHandler('limitConnectionReached'))
			socket.on('missingCredentials', () => errorHandler('missingCredentials'))
		})
	  }


}
